/* Keep mobile support clear of purchase controls, consent banners and homepage copy. */
(() => {
  if (window.eluneSupportPositionReady) return;
  window.eluneSupportPositionReady = true;
  const start = () => {
    const button = document.querySelector('.ef-float, .whatsapp-float');
    if (!button) return;
    const mobile = matchMedia('(max-width: 760px)');
    const gap = 16;
    let frame = 0;
    const observed = new WeakSet();
    const resize = new ResizeObserver(() => schedule());
    const visibleRect = el => {
      const r = el.getBoundingClientRect(), s = getComputedStyle(el);
      return r.width && r.height && s.visibility !== 'hidden' && s.display !== 'none' && r.bottom > 0 && r.top < innerHeight ? r : null;
    };
    const update = () => {
      frame = 0;
      if (!mobile.matches) {
        button.style.removeProperty('--elune-support-bottom');
        button.classList.remove('is-content-obscured');
        return;
      }
      const viewportBottom = visualViewport ? Math.min(innerHeight, visualViewport.offsetTop + visualViewport.height) : innerHeight;
      const b = button.getBoundingClientRect();
      let bottom = Math.max(16, innerHeight - viewportBottom + gap);
      const obstacles = [];
      document.querySelectorAll('[data-mobile-purchase], .shopify-cleanslate, #shopify-pc__banner, [id*="cookie" i], [class*="cookie-banner" i], [class*="consent-banner" i], form button[type="submit"], form .btn, form input[type="file"], [data-step-next], [data-sticky-label]').forEach(el => {
        if (el === button || button.contains(el)) return;
        const target = el.matches('input[type="file"]') ? (el.closest('label') || el) : el;
        const r = visibleRect(target);
        if (!r || r.right <= b.left || r.left >= b.right) return;
        if (!observed.has(el)) { resize.observe(target); observed.add(el); }
        // Ignore large app wrappers; their visible banner children are measured separately.
        if (el.matches('.shopify-cleanslate') && r.height > innerHeight * .6) return;
        obstacles.push(r);
      });
      for (let pass = 0; pass <= obstacles.length; pass++) {
        const top = innerHeight - bottom - b.height, end = innerHeight - bottom;
        const hits = obstacles.filter(r => top < r.bottom + gap && end > r.top - gap);
        if (!hits.length) break;
        bottom = Math.max(bottom, ...hits.map(r => innerHeight - r.top + gap));
      }
      // Full-screen consent dialogs own the screen; keep support beneath their layer.
      button.style.setProperty('--elune-support-bottom', `${Math.round(bottom)}px`);
      // Let homepage copy and calls to action occupy their full width. Keep the
      // support control in one place, revealing it again over images or whitespace.
      // Measuring after positioning also accounts for the device's safe-area inset.
      const supportRect = button.getBoundingClientRect();
      const home = document.querySelector('.eh-home');
      const engaged = button.matches(':focus-visible') || button.classList.contains('is-expanded');
      const contentOverlap = home && !engaged && [...home.querySelectorAll('h1,h2,h3,p,summary,.eh-button,.eh-link,.eh-styles,.eh-price,.eh-product-meta,figcaption')].some(el => {
        const r = visibleRect(el);
        return r && supportRect.left < r.right + 8 && supportRect.right > r.left - 8 && supportRect.top < r.bottom + 8 && supportRect.bottom > r.top - 8;
      });
      button.classList.toggle('is-content-obscured', Boolean(contentOverlap));
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    if (button.matches('a.ef-float')) {
      let lastPointerType = '';
      const closeExpanded = () => button.classList.remove('is-expanded');
      button.addEventListener('pointerdown', event => { lastPointerType = event.pointerType; });
      button.addEventListener('click', event => {
        const touchActivation = lastPointerType === 'touch' || event.pointerType === 'touch';
        lastPointerType = '';
        if (!touchActivation || event.detail === 0) return;
        if (button.classList.contains('is-expanded')) { closeExpanded(); return; }
        event.preventDefault();
        button.classList.add('is-expanded');
        schedule();
      });
      document.addEventListener('pointerdown', event => {
        if (!button.contains(event.target)) closeExpanded();
      });
      document.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        closeExpanded();
        if (document.activeElement === button) button.blur();
      });
      addEventListener('scroll', closeExpanded, {passive:true});
    }
    button.addEventListener('focus', schedule);
    button.addEventListener('blur', schedule);
    resize.observe(button);
    new MutationObserver(records => { if (records.some(r => r.target !== button)) schedule(); }).observe(document.body, {subtree:true, childList:true, attributes:true, attributeFilter:['hidden','class','style','open']});
    addEventListener('scroll', schedule, {passive:true});
    addEventListener('resize', schedule, {passive:true});
    visualViewport?.addEventListener('resize', schedule);
    visualViewport?.addEventListener('scroll', schedule);
    mobile.addEventListener('change', schedule);
    document.addEventListener('shopify:section:load', schedule);
    schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
})();

